// extracted by mini-css-extract-plugin
export default {"container":"SimpleInput_container__564DC","input":"SimpleInput_input__yjdu-","label":"SimpleInput_label__7z6c3"};